import {handleActions} from 'redux-actions';
import {ApplicationForAdmission} from '../constants/models';

const ApplicationForAdmissionReducers = handleActions({
    SET_APPLICATION_FOR_ADMISSION: (state, {payload}) => {
        // 直接使用API回傳的數據，不再進行URL處理
        return state.merge({
            data: payload
        });
    },
}, ApplicationForAdmission);

export default ApplicationForAdmissionReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/ApplicationForAdmissionReducers.jsx